import React from 'react'
import PropTypes from 'prop-types'
import Content from './Content'
import {Link} from 'gatsby'
import Img from 'gatsby-image'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleUp } from '@fortawesome/free-solid-svg-icons'
import { faTwitter, faFacebookF } from '@fortawesome/free-brands-svg-icons'

const UpdatesPageTemplate = ({ title, notice, content, externalLink, contentComponent, posts }) => {
  const PageContent = contentComponent || Content

  function Notice({notice}) {
    if(notice.title !== null) {
      return (
        <article className="message">
          <div className="message-header">
            {notice.title}
          </div>
          <div className="message-body">
            <p>{notice.message}</p>
          </div>
        </article>
      )
    }
    else {
      return (
        < ></ >
      )
    }
  }

  return (
    <section className="section section--gradient">
      <div className="container">
        <div className="columns">
          <div className="column is-8 is-offset-1">
            <div className="section">
              <h1 className="title is-size-1 has-text-weight-bold is-bold-light">
                {title}
              </h1>
              <PageContent className="content" content={content} />
            </div>
            <div className="news-preview-container">
              {posts.map(({ node: post }) =>(
                <div className="news-preview-item" key={post.id}>
                  <Img sizes={post.frontmatter.thumbnail.childImageSharp.sizes} alt="" style={{height: '154px', borderTopLeftRadius: '5px', borderTopRightRadius: '5px'}} />
                  <div className="news-preview-content">
                  <p className="is-size-5">{post.frontmatter.title}<br /><small className="accent-color">{post.frontmatter.date}</small></p>
                  </div>
                  <div className="news-preview-footer">
                    {
                        (post.frontmatter.externalLink === null) ? (
                          < >
                          <Link className="button is-white" to={post.fields.slug}>Read More</Link>
                          <div class="dropdown is-hoverable is-up">
                          <div class="dropdown-trigger">
                            <button class="button is-white" aria-haspopup="true" aria-controls="dropdown-menu4">
                              <span>Share</span>
                              <span className="icon is-small">
                              <FontAwesomeIcon icon={faAngleUp} />
                              </span>
                            </button>
                          </div>
                          <div class="dropdown-menu" id="dropdown-menu4" role="menu">
                            <div class="dropdown-content">
                              <a target="_blank" rel="noreferrer noopener" href={'http://www.twitter.com/share?url=https://gifted-lewin-c829e3.netlify.com'+post.fields.slug} className="dropdown-item">
                                <span className="icon">
                                <FontAwesomeIcon icon={faTwitter} />
                                </span>
                                Twitter
                              </a>
                              <hr class="dropdown-divider" />
                              <a target="_blank" rel="noreferrer noopener" href={'https://www.facebook.com/sharer/sharer.php?u=https://gifted-lewin-c829e3.netlify.com'+post.fields.slug} className="dropdown-item">
                                <span className="icon">
                                <FontAwesomeIcon icon={faFacebookF} />
                                </span>
                                Facebook
                              </a>
                            </div>
                          </div>
                        </div> 
                        </ >
                        ) : (
                          < >
                          <a target="_blank" rel="noopener noreferrer" href={post.frontmatter.externalLink} className="button is-white">Read More</a>
                          <div class="dropdown is-hoverable is-up">
                      <div class="dropdown-trigger">
                        <button class="button is-white" aria-haspopup="true" aria-controls="dropdown-menu4">
                          <span>Share</span>
                          <span className="icon is-small">
                          <FontAwesomeIcon icon={faAngleUp} />
                          </span>
                        </button>
                      </div>
                      <div class="dropdown-menu" id="dropdown-menu4" role="menu">
                        <div class="dropdown-content">
                          <a target="_blank" rel="noreferrer noopener" href={'http://www.twitter.com/share?url='+post.frontmatter.externalLink} className="dropdown-item">
                            <span className="icon">
                            <FontAwesomeIcon icon={faTwitter} />
                            </span>
                            Twitter
                          </a>
                          <hr class="dropdown-divider" />
                          <a target="_blank" rel="noreferrer noopener" href={'https://www.facebook.com/sharer/sharer.php?u='+post.frontmatter.externalLink} className="dropdown-item">
                            <span className="icon">
                            <FontAwesomeIcon icon={faFacebookF} />
                            </span>
                            Facebook
                          </a>
                        </div>
                      </div>
                    </div>
                    </ >
                        )
                    }
                  </div>
                </div>
                ))}
              </div>
            </div>
        </div>
      </div>
    </section>
  )
}

UpdatesPageTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
  contentComponent: PropTypes.func,
}

export default UpdatesPageTemplate
